import React from 'react';
import './Footer.css';
import logo from "../../../../../../../assets/logo.svg";
import logoText from "../../../../../../../assets/skali-logo-text.svg";
import twitter from "../../../../../../../assets/Twitter.svg";
import linkdin from "../../../../../../../assets/Linkedin.svg";
import comliantLogo from "../../../../../../../assets/footer-compliant-logo.png";

// Add your app store badges
import appStore from "../../../../../../../assets/icon-AppStore.png";
import playStore from "../../../../../../../assets/icon-GooglePlay.png";

const Footer = () => {
    return (
        <footer className='home-footer'>
            <div className='footer-container'>
                <div className='w-25'>
                    <div className='inner'>
                        <div className="logo-container">
                           <a href=''> <img src={logo} /></a>
                           <a href=''> <img className="logo-text" src={logoText} /></a>
                        </div>
                    </div>
                </div>
                <div className='w-25 m-2'>
                    <div className='inner social-icon'>
                        <div>
                            <p>Find us on Social Media</p>
                            <div className="icon-outer">
                                <a href='https://twitter.com/SkaliInc' target='__blank'><img src={twitter} alt='twitter' /></a>
                                <a style={{marginLeft: 10}} href='https://www.linkedin.com/company/skali-inc/' target='__blank'><img src={linkdin} alt='linkdin' /></a>
                            </div>
                        </div>
                        {/* ✅ New Section: App Store */}
                        <div className="app-links" style={{ marginTop: 20 }}>
                            <p>Download Our App</p>
                            <div className="app-badges" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                <a href="https://apps.apple.com/in/app/skali/id6480584448" target="_blank" rel="noreferrer">
                                    <img src={appStore} alt="Download on the App Store" style={{ height: "40px" }} />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.skali.app" target="_blank" rel="noreferrer">
                                    <img src={playStore} alt="Get it on Google Play" style={{ height: "40px" }} />
                                </a>
                            </div>
                        </div>
                        <div className='footer-compliant-logo'>
                            <img src={comliantLogo} alt="sael of compliant" />
                        </div>
                    </div>
                </div>
                <div className='w-25 m-3'>
                    <div className='inner'>
                        <h3 className='links'><a href='https://www.skalillc.com/how-it-works' target='__blank'>How it works</a></h3>
                        <ul className='link-list'>
                            <li>
                                <h3 className='inner-ui-head'>Solutions</h3>
                                <ul className='inner-list'>
                                    <li><a href='https://www.skalillc.com/for-aviation/' target='__blank'>For Aviation</a></li>
                                    <li><a href='https://www.skalillc.com/for-maritime/' target='__blank'>For Maritime</a></li>
                                    <li><a href='https://www.skalillc.com/for-oil-gas/' target='__blank'>For Oil & Gas</a></li>
                                    <li><a href='https://www.skalillc.com/for-military/' target='__blank'>For Military</a></li>
                                </ul>
                            </li>
                            <li><a href='https://www.skalillc.com/partners' target='__blank'>Partners</a></li>
                            <li><a href='https://www.skalillc.com/about-us' target='__blank'>About Us</a></li>
                            <li><a href='https://www.skalillc.com/faqs/' target='__blank'>FAQs</a></li>
                            <li><a href='https://skali.accountablehq.com/' target='__blank'>Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
                <div className='w-25 m-4'>
                    <div className='inner text-rigth'>
                       <a href='https://www.skalillc.com/lets-talk' target='__blank'> <button className='contact-btn' style={{cursor:"pointer"}}>Contact Us</button></a>
                    </div>
                </div>
            </div>
            <div className='all-right-reserve'>
                <p>2023 Skali. All Rights Reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
